import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicFourierEvenOdd = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="FOURIER SERIES FOR EVEN AND ODD FUNCTIONS"
      videos={[
        "https://www.youtube.com/embed/Mz0m-pmjykI?list=PLhSp9OSVmeyLke5_cby8i8ZhK8FHpw3qs",
        "https://www.youtube.com/embed/B-A2Os8LZMU?list=PLhSp9OSVmeyLke5_cby8i8ZhK8FHpw3qs"
      ]}
      takeaways={[
        {text:"Basic forms",
          image:"/fourier_1.png"
        }
      ]}
      questions={[]}
      exampleVideos={[]}
    />
);
}

export default ModuleSubtopicFourierEvenOdd;